webshop.ProductGrid = class {
	/* Options:
	        - items: Items
	        - settings: Webshop Settings
	        - products_section: Products Wrapper
	        - preference: If preference is not grid view, render but hide
	*/
	constructor(options) {
	        Object.assign(this, options);

	        if (this.preference !== "Grid View") {
	                        this.products_section.addClass("hidden");
	        }

	        this.products_section.empty();
	        this.make();
	}

	make() {
	        let me = this;
	let html = ``;

		this.items.forEach((item) => {
			let title = item.web_item_name || item.item_name || item.item_code || "";
			title = title.length > 90 ? title.substr(0, 90) + "..." : title;

			html += `<div class="col-sm-2 item-card"><div class="card text-left">`;
			html += me.get_image_html(item, title);
			html += me.get_card_body_html(item, title, me.settings);
			html += `</div></div>`;
		});

	        let $product_wrapper = this.products_section;
	        $product_wrapper.append(html);
	}

	get_image_html(item, title) {
	        let image = item.website_image;

	        if (image) {
	                        return `
	                                <div class="card-img-container">
		                                                <a href="/${ item.route || '#' }" style="text-decoration: none;">
		                                                        <img itemprop="image" class="card-img" src="${ image }" alt="${ title }">
		                                                </a>
	                                </div>
	                        `;
	        } else {
	                        return `
	                                <div class="card-img-container">
		                                                <a href="/${ item.route || '#' }" style="text-decoration: none;">
		                                                        <div class="card-img-top no-image">
		                                                                        ${ frappe.get_abbr(title) }
		                                                        </div>
		                                                </a>
	                                </div>
	                        `;
	        }
	}

	get_card_body_html(item, title, settings) {
		let body_html = `
			<div class="card-body text-left card-body-flex" style="width:100%; padding: 0.5rem;">
				<div style="margin-top: 0.5rem; display: flex;">
		`;
		body_html += this.get_title(item, title);

	        // get floating elements
	        if (!item.has_variants) {
	                        if (settings.enable_wishlist) {
	                                body_html += this.get_wishlist_icon(item);
	                        }
	                        if (settings.enabled) {
	                                body_html += this.get_cart_indicator(item);
	                        }

	        }

	        body_html += `</div>`;

	        // ADD BRAND HERE - after the title row, before the category
	        if (item.brand) {
	                        body_html += `<div class="product-brand small mb-1" style="color: var(--text-accent);">${ item.brand }</div>`;
	        }

	        body_html += `<div class="product-category" itemprop="name">${ item.item_group || '' }</div>`;

	        if (item.formatted_price) {
	                        body_html += this.get_price_html(item);
	        }

	        body_html += this.get_stock_availability(item, settings);
	        body_html += this.get_primary_button(item, settings);
	        body_html += `</div>`; // close div on line 49

	        return body_html;
	}

	get_title(item, title) {
	        let title_html = `
	                        <a href="/${ item.route || '#' }">
	                                <div class="product-title" itemprop="name">
		                                                ${ title || '' }
	                                </div>
	                        </a>
	        `;
	        return title_html;
	}

	get_wishlist_icon(item) {
	        let icon_class = item.wished ? "wished" : "not-wished";
	        return `
	                        <div class="like-action ${ item.wished ? "like-action-wished" : ''}"
	                                data-item-code="${ item.item_code }">
	                                <svg class="icon sm">
		                                                <use class="${ icon_class } wish-icon" href="#icon-heart"></use>
	                                </svg>
	                        </div>
	        `;
	}

	get_cart_indicator(item) {
	        return `
	                        <div class="cart-indicator ${item.in_cart ? '' : 'hidden'}" data-item-code="${ item.item_code }">
	                                1
	                        </div>
	        `;
	}

	get_price_html(item) {
	        let price_html = `
	                        <div class="product-price" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer">
	                                ${ item.formatted_price || '' }
	        `;

	        if (item.formatted_mrp) {
	                        price_html += `
	                                <small class="striked-price">
		                                                <s>${ item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : "" }</s>
	                                </small>
	                                <small class="ml-1 product-info-green">
		                                                ${ item.discount } ${ __("OFF") }
	                                </small>
	                        `;
	        }
	        price_html += `</div>`;
	        return price_html;
	}

	get_stock_availability(item, settings) {
	        // Show stock badge for templates (products with variants) and regular items
	        if (settings.show_stock_availability) {
	                // For template products (with variants) - show the aggregated stock status
	                if (item.has_variants && item.stock_status_color) {
	                        let badge_class = '';
	                        let icon = '';
	                        let label = item.stock_status_label || '';
	                        let bg_color = '';
	                        let text_color = 'white';
	                        
	                        if (item.stock_status_color == "green") {
	                                badge_class = 'badge-success';
	                                icon = '✓';
	                                bg_color = '#28a745';
	                        } else if (item.stock_status_color == "yellow") {
	                                badge_class = 'badge-warning';
	                                icon = '⚠';
	                                bg_color = '#ffc107';
	                                text_color = '#856404';
	                        } else if (item.stock_status_color == "red") {
	                                badge_class = 'badge-danger';
	                                icon = '✗';
	                                bg_color = '#dc3545';
	                        }
	                        
	                        return `
	                                <div class="stock-status mt-2 mb-2">
	                                        <span class="badge ${badge_class}" style="background-color: ${bg_color}; color: ${text_color}; padding: 5px 10px; border-radius: 4px; font-size: 12px; display: inline-block;">
	                                                ${icon} ${label}
	                                        </span>
	                                </div>
	                        `;
	                }
	                
	                // For regular items (without variants) - use original logic
	                if (!item.has_variants) {
	                        if (item.on_backorder) {
	                                return `
	                                        <span class="out-of-stock mb-2 mt-1" style="color: var(--primary-color)">
	                                                ${ __("Available on backorder") }
	                                        </span>
	                                `;
	                        } else if (!item.in_stock) {
	                                return `
	                                        <span class="out-of-stock mb-2 mt-1">
	                                                ${ __("Out of stock") }
	                                        </span>
	                                `;
	                        } else if (item.in_stock) {
	                                return `
	                                        <span class="in-stock mb-2 mt-1" style="color: #28a745;">
	                                                ${ __("In stock") }
	                                        </span>
	                                `;
	                        }
	                }
	        }

	        return ``;
	}

	get_primary_button(item, settings) {
	        if (item.has_variants) {
	                        return ``;
	        } else if (settings.enabled && (settings.allow_items_not_in_stock || item.in_stock)) {
	                        return `
	                                <div id="${ item.name }" class="btn
		                                                btn-sm btn-primary btn-add-to-cart-list
		                                                w-100 mt-2 ${ item.in_cart ? 'hidden' : '' }"
		                                                data-item-code="${ item.item_code }">
		                                                <span class="mr-2">
		                                                        <svg class="icon icon-md">
		                                                                        <use href="#icon-assets"></use>
		                                                        </svg>
		                                                </span>
		                                                ${ settings.enable_checkout ? __("Add to Cart") :  __("Add to Quote") }
	                                </div>

	                                <a href="/cart">
		                                                <div id="${ item.name }" class="btn
		                                                        btn-sm btn-primary btn-add-to-cart-list
		                                                        w-100 mt-4 go-to-cart-grid
		                                                        ${ item.in_cart ? '' : 'hidden' }"
		                                                        data-item-code="${ item.item_code }">
		                                                        ${ settings.enable_checkout ? __("Go to Cart") :  __("Go to Quote") }
		                                                </div>
	                                </a>
	                        `;
	        } else {
	                        return ``;
	        }
	}
};
